import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { IMember } from 'app/shared/Domains/member';
import { Router } from '@angular/router';
import { AppServiceManager } from 'common/services/appServiceManager';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { IMemberContact } from 'app/shared/Domains/memberContact';
import { ICompany } from 'app/shared/Domains/company';
import { IMemberFeeDetails } from 'app/shared/Domains/feeDetail';
import { IMemberFreezeDetail } from 'app/shared/Domains/memberFreezeDetail';
import { DatePipe } from '@angular/common';
import { IPackageBuider } from 'app/shared/Domains/packageBuilder';
import { IUser } from 'app/shared/Domains/IUser';
import { AuthService } from 'common/services/auth.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { IPackagePay } from 'app/shared/Domains/packagePay';
import { forkJoin } from 'rxjs';
import { Configuration } from 'config/config';

@Component({
  selector: 'app-supplier',
  templateUrl: './supplier.component.html',
  styleUrls: ['./supplier.component.css']
})
export class SupplierComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
